/* eslint-disable no-magic-numbers */
import GoalType from "@/constants/GoalType";
import moment from "moment-timezone";

export default {
	[ GoalType.ACTIVE ]: ( goal, timezone ) => {
		return !goal.archived &&
			moment.tz( goal.plannedStartDate, timezone ).unix() < moment.tz( timezone ).unix();
	},
	[ GoalType.DRAFT ]: ( goal, timezone ) => {
		return !goal.archived &&
			moment.tz( goal.plannedStartDate, timezone ).unix() >= moment.tz( timezone ).unix();
	},
	[ GoalType.ARCHIVED ]: goal => {
		return !!goal.archived;
	},
};



// WEBPACK FOOTER //
// ./src/components/Goals/GoalList/GoalTypeFilter.js